import get from 'lodash/get';
import * as types from './constants';
const defaultState = {
  loading: false,
  error: null,
  activeStep: 0,
  application: {},
  applicationInitalData: {},
  documents: [],
  property: {},
  brokers: {},
  Banklists: [],
  representativeDetails: [],
  applicationId: null,
  applicationType: '',
  propertyDocuments: null,
  contractDetails: {},
  registrationFeeDetails: {},
  breakdown: {},
  /** --------------- TRANSFER_OFFPLAN BANK MAKER --------------- */
  mortgageDetails: {
    startDate: '',
    endDate: '',
    mortgageAmount: null,
    mortgageTypeId: null,
    contractNumber: null,
    bankSignatoryId: null,
    valuationCompanyLicenseNumber: '',
    valuatorProfessionId: null,
  },
  mortgageTypes: null,
  bankSignatories: null,
  valuationCompanies: null,
  valuators: null,
  propertyDetails: {},
};

export default function transferOffPlan(state = defaultState, action = {}) {
  switch (action.type) {
    case types.CLEAR_TRANSFER_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        error: null,
      };
    case types.TRANSFER_OFFPLAN_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.FETCH_APPLICATION_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        broker: get(action.payload, 'broker', null),
        contractDetails: get(action.payload, 'contractDetails', {}),
        registrationFeeDetails: get(action.payload, 'registrationFeeDetails', {}),
        mortgageDetails: get(action.payload, 'mortgageDetails', {}),
        mortgageTypes: get(action.payload, 'mortgageTypes', null),
        bankSignatories: get(action.payload, 'bankSignatories', null),
        valuationCompanies: get(action.payload, 'valuationCompanies', null),
        valuators: get(action.payload, 'valuators', null),
        propertyDetails: get(action.payload, 'propertyDetails', {}),
      };
    case types.FETCH_PROPERTY_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        property: get(action.payload, 'property', {}),
      };
    case types.FETCH_BANKLIST_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        Banklists: get(action.payload, 'Banklists', []),
      };
    case types.FETCH_DOCUMENTS_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        documents: get(action.payload, 'documents', []),
      };

    case types.TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        brokers: get(action.payload, 'brokers', null),
        contractDetails: get(action.payload, 'contractDetails', {}),
        registrationFeeDetails: get(action.payload, 'registrationFeeDetails', {}),
      };
    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_FAIL:
      return {
        ...state,
        loading: false,
      };
    case types.INITIATE_TRANSFER_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.CHANGE_TRANSFER_OFFPLAN_STEP:
      return {
        ...state,
        activeStep: get(action.payload, 'step'),
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        documents: get(action.payload, 'documents', []),
      };
    case types.UPLOAD_TRANSFER_OFFPLAN_DOCUMENT_ERROR: {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    }
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case types.DOWNLOAD_DOCUMENT_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ADD_TO_ERROR_INITITATE:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case types.ADD_TO_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
        // application: get(action.payload, 'application', {}),
        error: null,
      };

    case types.SAVE_APPLICATION_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.TRANSFER_OFFPLAN_CANCEL_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.SET_CONTRACT_DETAILS_TEST:
      return {
        ...state,
        contractDetails: { ...state.contractDetails, [action.payload.key]: action.payload.value },
      };
    case types.SET_REGESTRATION_FEES_PAID_BY:
      return {
        ...state,
        registrationFeeDetails: { ...state.registrationFeeDetails, [action.payload.key]: action.payload.value },
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION:
      return {
        ...state,
        loading: true,
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        activeStep: 0,
      };
    case types.CHECKOUT_TRANSFER_OFFPLAN_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.ENROLL_PROPERTY_IN_TAWTHEEQ:
      return {
        ...state,
        registrationFeeDetails: {
          ...state.registrationFeeDetails,
          enrollPropertyInTawteeq: !state.registrationFeeDetails.enrollPropertyInTawteeq,
        },
      };

    /** --------------- TRANSFER_OFFPLAN BANK MAKER --------------- */
    case types.SET_TRANSFER_OFFPLAN_BANK_MAKER_DETAILS:
      return {
        ...state,
        mortgageDetails: { ...state.mortgageDetails, [action.payload.key]: action.payload.value },
      };

    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        application: null,
      };
    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', []),
        property: get(action.payload, 'property', {}),
        mortgageDetails: get(action.payload, 'mortgageDetails', {}),
        mortgageTypes: get(action.payload, 'mortgageTypes', []),
        bankSignatories: get(action.payload, 'bankSignatories', []),
        valuationCompanies: get(action.payload, 'valuationCompanies', []),
        contractDetails: get(action.payload, 'contractDetails', {}),
      };
    case types.FETCH_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS:
      return {
        ...state,
        loading: true,
        error: null,
        valuators: [],
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        valuators: get(action.payload, 'valuators', []),
      };
    case types.FETCH_TRANSFER_OFFPLAN_VALUATORS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
        valuators: [],
      };

    case types.CLEAR_TRANSFER_OFFPLAN_VALUATORS:
      return {
        ...state,
        valuators: [],
        mortgageDetails: { ...state.mortgageDetails, valuatorProfessionId: null },
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_SUCCESS:
      return {
        ...state,
        loading: false,
        application: get(action.payload, 'application', {}),
        applicationId: get(action.payload, 'applicationId', {}),
        documents: get(action.payload, 'documents', {}),
        property: get(action.payload, 'property', {}),
        activeStep: get(action.payload, 'step'),
        error: null,
      };

    case types.SAVE_TRANSFER_OFFPLAN_BANK_MAKER_APPLICATION_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    // post flow
    case types.APPROVAL_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.APPROVAL_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.APPROVAL_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case types.POST_RETURN_TRANSFER_OFFPLAN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_SUCCESS:
      return {
        ...state,
        loading: false,
        breakdown: get(action.payload, 'breakdown', {}),
      };
    case types.TRANSFER_OFFPLAN_PAYMENT_BREAKDOWN_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case types.TRANSFER_OFFPLAN_CLEAR_DATA:
      return {
        ...defaultState,
      };
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null,
      };
    }
    case types.DOWNLOAD_TRANSFEER_OFFPLAN_CONTRACT_DOCUMENT_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case types.FETCH_TRANSFER_OFFPLAN_PREMISE_ADDRESS_SUCCESS:
      const premiseNumber = get(action.payload, 'premise.result.premiseDetailResponse.premiseID');
      const premisesAddress = get(action.payload, 'premise.result.premiseDetailResponse.premiseAddress');
      return {
        ...state,
        loading: false,
        propertyDetails: {
          premiseNumber,
          premisesAddress,
        },
      };
    case types.SET_TRANSFER_OFFPLAN_PREMISE_NUMBER:
      return {
        ...state,
        loading: false,
        propertyDetails: {
          premiseNumber: get(action.payload, 'premiseNumber', ''),
          premiseAddress: '',
        },
      };
    default:
      return state;
  }
}
